// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mat-column-submitterMailSendStatus.filter-th {
    width: 10em;
  }
.mat-column-mailSendStatus.filter-th {
    width: 10em;
  }
  
  .mat-column-submitterMailSendStatus,
  .mat-column-actions {
    text-align: center;
    padding-right: 0 !important;
    min-width: 9em;
  }
  .mat-column-submitionDate {
    text-align: center;
    padding-right: 0 !important;
    min-width: 9em;
  }
  .th.mat-header-cell{
    text-align: center;
  }
  td.mat-cell.cdk-column-FormName.mat-column-FormName {
    text-align: center;
  }
  td.mat-cell.cdk-column-FormData.mat-column-FormData {
    text-align: center;
  }
  td.mat-cell.cdk-column-mailSender.mat-column-mailSender {
    text-align: center;
  }
  
  .mat-table__wrapper {
    overflow: auto;
  }`, "",{"version":3,"sources":["webpack://./src/app/views/submit-forms/submit-forms.component.css"],"names":[],"mappings":"AAAA;IACI,WAAW;EACb;AACF;IACI,WAAW;EACb;;EAEA;;IAEE,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;EAChB;EACA;IACE,kBAAkB;IAClB,2BAA2B;IAC3B,cAAc;EAChB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;EACA;IACE,kBAAkB;EACpB;;EAEA;IACE,cAAc;EAChB","sourcesContent":[".mat-column-submitterMailSendStatus.filter-th {\r\n    width: 10em;\r\n  }\r\n.mat-column-mailSendStatus.filter-th {\r\n    width: 10em;\r\n  }\r\n  \r\n  .mat-column-submitterMailSendStatus,\r\n  .mat-column-actions {\r\n    text-align: center;\r\n    padding-right: 0 !important;\r\n    min-width: 9em;\r\n  }\r\n  .mat-column-submitionDate {\r\n    text-align: center;\r\n    padding-right: 0 !important;\r\n    min-width: 9em;\r\n  }\r\n  .th.mat-header-cell{\r\n    text-align: center;\r\n  }\r\n  td.mat-cell.cdk-column-FormName.mat-column-FormName {\r\n    text-align: center;\r\n  }\r\n  td.mat-cell.cdk-column-FormData.mat-column-FormData {\r\n    text-align: center;\r\n  }\r\n  td.mat-cell.cdk-column-mailSender.mat-column-mailSender {\r\n    text-align: center;\r\n  }\r\n  \r\n  .mat-table__wrapper {\r\n    overflow: auto;\r\n  }"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
